import React from "react";

type SvgProps = React.SVGProps<SVGSVGElement>;

export const AssigneePerson = (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8165_826)">
      <path
        d="M10.5 12.0002H9.5V9.47874C9.4996 9.08674 9.34371 8.71091 9.06652 8.43373C8.78933 8.15654 8.4135 8.00064 8.0215 8.00024H3.9785C3.5865 8.00064 3.21067 8.15654 2.93348 8.43373C2.65629 8.71091 2.5004 9.08674 2.5 9.47874V12.0002H1.5V9.47874C1.50079 8.82165 1.76218 8.19169 2.22681 7.72706C2.69145 7.26242 3.3214 7.00104 3.9785 7.00024H8.0215C8.6786 7.00104 9.30855 7.26242 9.77319 7.72706C10.2378 8.19169 10.4992 8.82165 10.5 9.47874V12.0002Z"
        fill="#481DD6"
      />
      <path
        d="M6 6C5.40666 6 4.82664 5.82406 4.33329 5.49441C3.83994 5.16477 3.45543 4.69623 3.22836 4.14805C3.0013 3.59987 2.94189 2.99667 3.05765 2.41473C3.1734 1.83279 3.45912 1.29824 3.87868 0.878681C4.29824 0.459124 4.83279 0.173401 5.41473 0.0576455C5.99667 -0.0581102 6.59987 0.00129986 7.14805 0.228363C7.69623 0.455426 8.16477 0.839943 8.49441 1.33329C8.82406 1.82664 9 2.40666 9 3C8.99921 3.79541 8.68288 4.55801 8.12045 5.12045C7.55801 5.68288 6.79541 5.99921 6 6ZM6 1C5.60444 1 5.21776 1.1173 4.88886 1.33706C4.55996 1.55683 4.30362 1.86918 4.15224 2.23463C4.00087 2.60009 3.96126 3.00222 4.03843 3.39018C4.1156 3.77814 4.30608 4.13451 4.58579 4.41422C4.86549 4.69392 5.22186 4.8844 5.60982 4.96157C5.99778 5.03874 6.39992 4.99914 6.76537 4.84776C7.13082 4.69639 7.44318 4.44004 7.66294 4.11114C7.8827 3.78224 8 3.39556 8 3C8 2.46957 7.78929 1.96086 7.41422 1.58579C7.03914 1.21072 6.53043 1 6 1Z"
        fill="#481DD6"
      />
    </g>
    <defs>
      <clipPath id="clip0_8165_826">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
